export const exhaustiveCheck = (param: never) => {
  console.error(`Обработайте значение ${param}`);
};
